import templateUrl from './closure.html';

export default {
  templateUrl,
  bindings: {
    adverseEvent: '<',
    statuses: '<',
    locked: '<',
    onClosed: '&'
  },
  controller: class ClosureComponent {
    constructor(EventEmitter) {
      'ngInject';

      Object.assign(this, { EventEmitter });
    }

    onSubmit() {
      this.onClosed(
        this.EventEmitter({
          adverseEvent: this.adverseEvent
        })
      );
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/adverse-event/closure/closure.component.js